import axios from 'axios';

// eslint-disable-next-line import/no-mutable-exports
let api = axios.create({
  baseURL: process.env.VUE_APP_NEXTPORT_API_BASE_URL,
  timeout: 360000,
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'Ocp-Apim-Subscription-Key': process.env.VUE_APP_NEXTPORT_API_KEY,
  },
});

const createApi = () => {
  api = axios.create({
    baseURL: process.env.VUE_APP_NEXTPORT_API_BASE_URL,
    timeout: 360000,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      'Ocp-Apim-Subscription-Key': process.env.VUE_APP_NEXTPORT_API_KEY,
    },
  });
};

// eslint-disable-next-line import/prefer-default-export
export {
  api,
  createApi,
};
